// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".xpathForm form input{margin-bottom:0px !important}.xpathForm form textarea{margin-top:5px;margin-bottom:10px}.textareaLabel{width:20% !important}.ml-40{margin-left:-40px !important}\n", ""]);
// Exports
module.exports = exports;
